import { Expose } from 'class-transformer'

export class ChallengeLevelType {
  @Expose() id: number

  @Expose() iconUrl?: string

  @Expose() isActive: boolean
}
